/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'health-monitor';

export const healthMonitorBreadcrumbTitle = `${prefix}.healthMonitorBreadcrumbTitle`;
export const http2Label = `${prefix}.http2Label`;
export const http2sLabel = `${prefix}.http2sLabel`;

export const ENGLISH = {
    [healthMonitorBreadcrumbTitle]: 'Health Monitor',
    [http2Label]: 'HTTP2',
    [http2sLabel]: 'HTTP2S',
};
